import { useAtom } from 'jotai';
import React from 'react';
import ArrowLeft from '@assets/icons/arrow-left';
import { useViewWidth } from '@utils/helpers/viewWidth';
import {
  extendedFilterAtom,
  filterOptionType,
  selectedFilterOptionAtom,
  showAllFilterAtom,
} from '@atom/examResultAtom';
import { selectedOptionProps } from './FilterOnMobileAndTablet';

export type filterListProps = {
  id: 'subject' | 'level' | 'type';
  titleList: string;
  list: filterOptionType[];
  inExtendedSheet?: boolean;
  onClick: (arg: selectedOptionProps) => void;
};

const breakpoint = require('geniebook-ui/dist/themes/breakpoint');
const FilterList = (props: filterListProps) => {
  const width = useViewWidth();
  const {
    id,
    titleList,
    list,
    inExtendedSheet = false,
    onClick: selectOption,
  } = props;
  const [selectedOption] = useAtom(selectedFilterOptionAtom);
  const [showAllFilter, setShowAllFilter] = useAtom(showAllFilterAtom);
  const [, setExtendedFilter] = useAtom(extendedFilterAtom);
  const maxItemPerCategory = width > breakpoint.sm ? 4 : 3;

  const handleShowAllTextLink = () => {
    setShowAllFilter(!showAllFilter);
    setExtendedFilter({ id, titleList, list });
  };

  const optionFilterMap = {
    subject: selectedOption.subject,
    level: selectedOption.level,
    type: selectedOption.type,
  };

  const selectedOptionFilter = optionFilterMap[id];

  return (
    <section className="flex flex-col gap-y-2">
      <div className="flex justify-between px-4">
        {inExtendedSheet ? (
          <div className="flex items-center justify-center gap-3">
            <ArrowLeft
              className={'fill-current text-primary-apricot w-3 text-sm'}
              data-testid={'back-button'}
            />
            <span className="text-primary-navyblue font-extrabold">
              {titleList}
            </span>
          </div>
        ) : (
          <p className="text-neutral-graphite text-xs font-semibold uppercase">
            {titleList}
          </p>
        )}

        {list.length > maxItemPerCategory && !inExtendedSheet && (
          <button
            className="font-inherit text-primary-apricot flex cursor-pointer items-center justify-center border-none bg-none p-0 text-xs font-medium underline exclude-element2"
            onClick={handleShowAllTextLink}
          >
            Show all
          </button>
        )}
      </div>

      <ul className="text-primary-navyblue list-none">
        {(inExtendedSheet ? list : list.slice(0, maxItemPerCategory)).map(
          item => (
            <li
              key={`${item.label}-${item.value}`}
              className={`px-4 hover:cursor-pointer ${
                selectedOptionFilter === item.value && 'bg-[#f5f7fc]'
              }`}
            >
              <button
                className="w-full h-full py-2 text-left"
                onClick={() => selectOption({ id, item: item.value })}
              >
                {item.label}
              </button>
            </li>
          ),
        )}
      </ul>
    </section>
  );
};

export default FilterList;
